export default {
  invoice: {},
  yapayData: '',
  passwordYapay: '',
  emailYapay: '',
  splits: {}
}



// WEBPACK FOOTER //
// ./src/app/pages/payments/vuex/state.js